import React, { useEffect, useMemo } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Card, Typography, Tag, Spin } from 'antd'
import {
  selectImportLogById,
  isFetchingImportLogs,
  getWeeklyNpeesUpdatesById,
} from '../../../state/modules/importLogs'
import PageLayout from '../../layouts/DetailPageLayout'
import Table from '../../components/Tables/SearchTable'
import useDispatchHttp from '../../../hooks/dispatchHttpHandler'
import { mapImportLogsStatusColor } from '../../../utils/helpers'

const RenderImportLogTableTitle = fileUrl => {
  const fileNameParts = fileUrl?.split('/') || []
  const title = fileNameParts[fileNameParts.length - 1] || 'Title'

  return <Typography.Link href={fileUrl}>{title}</Typography.Link>
}

const RenderImportLogTableStatus = status => (
  <Tag color={mapImportLogsStatusColor(status)}>{status}</Tag>
)

const columns = [
  { title: 'ID', key: 'id' },
  { title: 'Date | Time', key: 'created_at', date: true },
  { title: 'Title', key: 'file_url', render: RenderImportLogTableTitle },
  { title: 'Status', key: 'status', render: RenderImportLogTableStatus },
  { title: 'Total Doctors Imported', key: 'total_doctors_imported' },
  { title: 'Total Facilities Imported', key: 'total_facilities_imported' },
]

const WeeklyNpeesUpdatesDetails = () => {
  const dispatchHttp = useDispatchHttp()
  const { id } = useParams()

  const { state, search } = useLocation()
  const query = useMemo(() => new URLSearchParams(search), [search])

  const returnPage = state?.returnPage || Number(query.get('page')) || 1
  const returnPageSize = state?.returnPageSize || Number(query.get('pageSize')) || 10

  const importLog = useSelector(currentState => selectImportLogById(currentState, id))
  const loading = useSelector(isFetchingImportLogs)
  const fileNameParts = importLog?.file_url?.split('/') || []
  const title = fileNameParts[fileNameParts.length - 1] || 'Title'

  const backLinkParams = useMemo(() => {
    const params = new URLSearchParams()
    params.set('tab', '3')
    params.set('page', returnPage)
    params.set('pageSize', returnPageSize)
    return params.toString()
  }, [returnPage, returnPageSize])

  const breadcrumbs = [
    { name: 'Import Log', path: '/data-sync-log' },
    {
      name: 'Weekly NPPES Updates',
      path: `/data-sync-log?${backLinkParams}`,
    },
    {
      name: title,
      path: `/data-sync-log-weekly-npees-updates/${importLog?.id}`,
    },
  ]

  useEffect(() => {
    dispatchHttp(getWeeklyNpeesUpdatesById(id))
  }, [dispatchHttp, id])

  return (
    <PageLayout breadcrumbs={breadcrumbs} title={title}>
      <Spin spinning={loading}>
        <Card style={{ width: '100%' }} className="weekly-npees-updates">
          <Table
            columns={columns}
            tableTitle="Import Log"
            loading={loading}
            totalData={importLog ? [importLog] : []}
          />
        </Card>
      </Spin>
    </PageLayout>
  )
}

export default WeeklyNpeesUpdatesDetails
